<template>
  <div
    id="main-nav"
    :data-testid="dataTestid"
    class="relative z-[99] safezone-x"
    :class="{
      'shadow-md': ctaOnly,
    }"
  >
    <div
      class="bg-semantic-inverse-surface-light relative w-full z-[999]"
      :class="{
        'shadow-header': hasShadow,
        'shadow-sm': !hasShadow,
      }"
      @click="hideMenu"
    >
      <div
        ref="mainMenu"
        class="flex justify-between items-center max-w-8xxl mx-auto lg:pl-8 lg:pr-6 xl:px-14 flex-wrap lg:flex-nowrap h-[4rem] overflow-hidden"
        @click="hideMenu"
      >
        <div class="flex items-center h-[4rem] order-1">
          <NuxtLink to="/">
            <img
              height="28"
              width="167"
              class="min-w-[9rem] max-w-[9rem] xs:max-w-unset xs:min-w-[10.4375rem] lg:w-auto py-3 pl-4"
              src="/images/cc-logo-white-text.svg"
              alt="Compare Club"
            />
          </NuxtLink>
        </div>

        <!-- NAV ITEMS -->
        <template v-if="!ctaOnly">
          <V2AtomsMenu
            v-show="showMegaMenu"
            id="nav-menu"
            class="hidden xl:flex w-full bg-semantic-inverse-surface-light h-[3.875rem] lg:h-[4rem] xl:flex-1 order-3 lg:order-2 border-t-gray-400 border-t lg:border-t-0 shadow-header-inset-light lg:shadow-none"
          >
            <V2AtomsMenuItem
              v-for="item in menu"
              :key="item?.slug"
              :icon-component="item.iconComponent || null"
              :active="currMenu?.slug === item.slug"
              @click.stop="setCurrentMenu(item)"
            >
              {{ item.title }}
              
              <template #after>
                <V2OrganismNavBarMegaMenuDesktop
                  v-show="showMegaMenuFlag && currMenu?.slug === item.slug"
                  class="absolute top-full left-0"
                  :curr-menu="currMenu"
                  @click.stop="resetCurrentMenu"
                />
              </template>
            </V2AtomsMenuItem>
          </V2AtomsMenu>

          <!-- OTHER MENU -->
          <V2AtomsMenu class="order-2 lg:order-3 h-[4rem]">
            <!-- USER LOGIN -->
            <template v-if="!userLoggedIn && !hideSignupButtons">
              <AtomsMenuItem
                :has-background-when-active="false"
                padding="small"
                :to="!hasLoginPopup ? generateLoginPageUrl() : null"
                theme="global-navbar"
                class="menu-other min-w-12 xs:min-w-[3.25rem]"
                :class="{
                  'order-3 lg:order-none': rearrangeMenu,
                }"
                inner-wrapper-class="!justify-center"
                @click="showClubPlusLogin"
              >
                <img
                  src="/icons/user.svg"
                  alt="user"
                  class="ml-0 wh-8 md:wh-6"
                />

                <span
                  class="hidden lg:block text-semantic-inverse-on-surface ml-2 mr-0 font-bold opacity-85 hover:opacity-100 transition-opacity"
                >
                  Login
                </span>
              </AtomsMenuItem>

              <AtomsMenuItem
                :has-background-when-active="false"
                padding="small"
                :to="!hasLoginPopup ? generateRegisterPageUrl() : null"
                theme="global-navbar"
                class="menu-other hidden lg:inline-flex"
                inner-wrapper-class=""
                @click="showClubPlusLogin"
              >
                <atoms-button
                  id="navbar_auth_register_btn"
                  size="small"
                  class="!h-auto"
                  inverted>
                  Join the Club
                </atoms-button>
              </AtomsMenuItem>
            </template>

            <!-- PHONE MOBILE -->
            <template
              v-if="
                devices.breakpoint('md', 'max') &&
                  !ctaOnly &&
                  verticalData?.phoneNumber !== '' &&
                  hasCallCta &&
                  (layout === 'default' ||
                    (layout === 'minimal' && (isQuoteResults || !userLoggedIn)))
              "
            >
              <atoms-menu-item
                class="xl:hidden min-w-12 xs:min-w-[3.25rem]"
                padding="none"
                inner-wrapper-class="justify-center"
                :class="[
                  {
                    'min-w-[3.25rem]': !userLoggedIn && layout === 'minimal',
                    'order-1 lg:order-none': rearrangeMenu,
                  },
                ]"
                :to="`tel:${verticalData?.phoneNumber}`"
                :has-background-when-active="false"
              >
                <img
                  src="/icons/phone-primary.svg"
                  class="w-6 h-6 mx-auto"
                  alt="phone"
                  width="24"
                  height="24"
                />
              </atoms-menu-item>
            </template>

            <!-- NOTIFICATION -->
            <template
              v-if="
                !ctaOnly &&
                  (layout === 'default' || hideSignupButtons) &&
                  userLoggedIn &&
                  enableContentCardNotifications
              "
            >
              <MoleculesNavNotification />
            </template>

            <!-- NAV PROFILE -->
            <template
              v-if="
                userLoggedIn &&
                  (layout === 'default' ||
                    (layout === 'minimal' && forceShowNavProfile) ||
                    (layout === 'minimal' && devices.breakpoint('lg')))
              "
            >
              <OrganismsDashboardHeaderUserMenu />
            </template>

            <!-- SPEAK TO US -->
            <template v-if="verticalData?.phoneNumber !== '' && hasCallCta">
              <V2AtomsMenuDivider />
              <atoms-menu-item
                :to="`tel:${verticalData?.phoneNumber}`"
                :has-background-when-active="false"
                class="menu-other relative min-w-[8.25rem] hidden lg:inline-flex"
                padding="none"
                @mouseover="!isHealthInsurance && (showSpeakToUsTooltip = true)"
                @mouseleave="!isHealthInsurance && (showSpeakToUsTooltip = false)"
              >
                <div class="block text-right">
                  <div class="flex items-center justify-end mt-3">
                    <img
                      src="/icons/phone-primary.svg"
                      class="mr-1"
                      alt="phone"
                      width="14"
                      height="14"
                    />

                    <V2AtomsLabel size="small" class="text-xs px-2">
                      Speak to us
                    </V2AtomsLabel>
                  </div>

                  <div class="flex items-center justify-end mb-2">
                    <span class="text-semantic-inverse-on-surface text-base">
                      {{
                        verticalData?.phoneNumberDisplay ||
                          verticalData?.phoneNumber
                      }}
                    </span>
                  </div>
                </div>

                <atoms-tooltip
                  v-if="!isHealthInsurance"
                  v-model="showSpeakToUsTooltip"
                  type="call-hours"
                  tip-x="right"
                  tip-y="top"
                  :has-icon="false"
                  class="absolute right-6 top-14 w-[12.25rem] z-[51] text-left"
                  @mouseover="showSpeakToUsTooltip = true"
                  @mouseleave.stop
                >
                  <img
                    src="/icons/clock.svg"
                    class="mt-[0.125rem] mr-[0.313rem] inline-block align-top"
                    alt="clock"
                    :width="12.94"
                  />

                  <p class="inline-block text-left">
                    <span class="flex items-center justify-start">
                      {{ verticalData?.schedule }}
                    </span>

                    <span class="flex items-center justify-start">
                      {{ verticalData?.schedule_weekend }}
                    </span>
                  </p>
                </atoms-tooltip>
              </atoms-menu-item>
            </template>

            <!-- HAMBURGER -->
            <template v-if="!ctaOnly && layout === 'default'">
              <li
                class="min-w-[2.5rem] xl:hidden"
                :class="{
                  'order-5 lg:order-none': rearrangeMenu,
                }"
              >
                <button
                  class="inline-flex items-center text-sm h-full w-full"
                  type="button"
                  @click.stop="toggleMegaMenu"
                >
                  <img
                    v-show="!showMegaMenuFlag"
                    src="/icons/burger-light.svg"
                    alt="burger"
                    class="mx-auto wh-8 md:wh-6 md:w-auto"
                  />

                  <V2IconsClose
                    v-show="showMegaMenuFlag"
                    alt="close"
                    :fill="semanticColorLookup('inverse.on-surface')"
                    class="mx-auto wh-8 md:wh-6 md:w-auto"
                  />
                </button>
              </li>
            </template>
          </V2AtomsMenu>
        </template>

        <!-- FOR CONTENTFUL ARTICLELIGHTWITHSIDEBAR -->
        <div v-else class="py-3 order-2 pr-4">
          <atoms-cta
            :to="verticalData?.formPage"
            :size="devices.breakpoint('md') ? 'medium' : 'xsmall'"
            theme="primaryWhite"
            class="font-bold px-4"
          >
            {{ ctaText }}
          </atoms-cta>
        </div>

        <V2OrganismNavBarMegaMenuMobile
          v-model="showMegaMenuFlag"
          class="absolute top-full left-0"
          :menu="menu"
        />
      </div>
    </div>

    <div
      v-if="showMegaMenuFlag"
      ref="backdrop"
      class="bg-black fixed w-full h-full top-0 left-0 z-[60] opacity-50 block"
      @click="hideMenu"
    />

    <!-- <MoleculesRateRiseNudgeBar /> -->
    <!-- <MoleculesRateRiseCountdown /> -->

    <!--
      Kept mounted while an MFA step is showing: logging in flips userLoggedIn true, which
      would otherwise unmount the modal mid-challenge or mid-enrolment. See mfaStepActive in
      organisms/Authentication.
    -->
    <OrganismsMemberhubModalAuthentication
      v-if="hasLoginPopup && (!userLoggedIn || mfaStepActive)"
    />
  </div>
</template>

<script setup>
import { NAV_MENU_OBJ } from '~/constants/navbar.constants'

defineOptions({
  name: 'V2OrganismNavBar'
})

const props = defineProps({
  dataTestid: {
    type: String,
    default: ''
  },

  layout: {
    type: String,
    default: 'default',
    validator: value => ['default', 'minimal'].includes(value)
  },

  ctaOnly: {
    type: Boolean,
    default: false
  },

  ctaText: {
    type: String,
    default: 'Get free quotes'
  },

  hasShadow: {
    type: Boolean,
    default: false
  },

  hasCallCta: {
    type: Boolean,
    default: true
  },

  hideSignupButtons: {
    type: Boolean,
    default: false
  },

  hasLoginPopup: {
    type: Boolean,
    default: false
  }
})

const { devices } = deviceChecker()
const { $tracking, $bus } = useNuxtApp()

const { fetchMenuArticles } = useNavigationStore()
const userStore = useUserStore()

const { enableContentCardNotifications } = useRuntimeConfig().public

const route = useRoute()

/**
 * Fetch the article list for feature menu items
 *
 * Populates the navigation store's `featuredMenu` state, but nothing currently
 * reads that state (or the `featuredMenuItems` getter) back out — the menu
 * rendered below comes from the static NAV_MENU_OBJ constant instead.
 */
if (import.meta.server) {
  try {
    await fetchMenuArticles({ verticals: VERTICAL_LIST })
  } catch (error) {
    throw new Error('Navigation:fetchData:Fail:' + String(error), { cause: error })
  }
}

const mainMenu = ref(null)
const currMenu = ref({})
const showSpeakToUsTooltip = ref(false)
const showMegaMenuFlag = ref(false)

const isClient = computed(() => import.meta.client)

const showMegaMenu = computed(() => {
  if (!isClient.value) {
    return true
  }

  // hide for mobile
  if (!devices.breakpoint('md', 'max')) {
    return true
  }

  return showMegaMenuFlag.value
})

const userLoggedIn = computed(() => userStore.isUserLoggedIn)
const mfaStepActive = useState('auth:mfa-step-active', () => false)
const rearrangeMenu = computed(
  () => props.layout === 'default' && !userLoggedIn.value
)

const menu = computed(() => {
  if (props.layout === 'minimal') {
    return []
  }

  return NAV_MENU_OBJ
})

const forceShowNavProfile = computed(() => {
  const _path = route.path

  return _path.includes('dashboard') || _path.includes('quotes-results')
})

const isQuoteResults = computed(() => route.path.includes('quotes-results'))
const isHealthInsurance = computed(() => route.path.startsWith('/health-insurance'))

const verticalData = computed(() => {
  const data = { ...VERTICALS?.['Default'] }

  const isIncomeProtection = route.path.includes('income-protection')
  const isOVHC = route.path.includes('visitors-visa-ovhc')

  if (isIncomeProtection) {
    data.schedule = 'Mon-Thu 9:30am-6pm AEST'
    data.schedule_weekend = 'Fri 9am-5pm AEST'
  }

  if (isOVHC) {
    data.phoneNumber = '1300 084 008'
    data.phoneNumberDisplay = '1300 084 008'
  }

  return data
})

onMounted(async () => {
  await nextTick()

  if (mainMenu.value) {
    mainMenu.value.style.height = 'auto'
    mainMenu.value.style.overflow = 'unset'
  }
})
function resetCurrentMenu () {
  currMenu.value = {}
  showMegaMenuFlag.value = false
}

function setCurrentMenu (val) {
  currMenu.value = val
  showMegaMenuFlag.value = true
}

function hideMenu ($event) {
  const type = $event.type

  if (
    (['mouseleave', 'mouseover'].includes(type) && devices.breakpoint('lg')) ||
    type === 'click'
  ) {
    showMegaMenuFlag.value = false
    currMenu.value = {}
  }
}

function toggleMegaMenu () {
  showMegaMenuFlag.value = !showMegaMenuFlag.value
  currMenu.value = menu.value.length ? menu.value[0] : {}
}

function showClubPlusLogin () {
  if (props.hasLoginPopup) {
    $tracking.customEvent('Club+ Modal', {})
    $bus.emit('mh-auth', {
      source_page_url: route.fullPath,
      query: route.query
    })
  }
}
</script>